import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

// Let import icons
import search from '../img/search.svg'

// Lets import components
import SocialNetworks from './SocialNetworks/SocialNetworks'
import LanguageSwitcher from '../components/LanguageSwitcher/LanguageSwitcher'

// Lets import icons
import ueFlag from '../img/eu.png'

// Lets import styles for component
import './Navbar.sass'

class Navbar extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
    }
  }

  handleChange = event => {
    const value = event.currentTarget.value
    this.setState(() => {
      return {
        value,
      }
    }) 
  }

  onKeyPress = event => {
    const keyCode = event.which || event.keyCode
    if (keyCode === 13) {
      this.searchEvent()
    }
  }

  searchEvent = () => {
    const {value} = this.state
    window.open(`https://www.euneighbours.eu/search/all?keys=${value}`, '_blank')
  }

  render() {
    const {socialNetworks, t} = this.props
    const { value } = this.state
    return (
      <header>
        <div className="menuWrap">
          <div className="flexWrap">
            <div className="left">
              <div className="ueFlag">
                <img src={ueFlag} alt='ue flag' />
              </div>
            </div>
            <div className="right">
              <div className="menu">
                <ul>
                  <li>
                    <a 
                      href="https://www.euneighbours.eu/user/login"
                      aria-label={t('header_login')}
                    >
                      {t('header_login')}
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.euneighbours.eu/user/register"
                      aria-label={t('header_signup')}
                    >
                      {t('header_signup')}
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.euneighbours.eu/policy"
                      aria-label={t('header_policy')}
                    >
                      {t('header_policy')}
                    </a>
                  </li>
                  <li>
                    <a 
                      href="https://www.euneighbours.eu/contact"
                      aria-label={t('header_contact')}
                    >
                      {t('header_contact')}
                    </a>
                  </li>
                  <li>
                    <a 
                      href="http://library.euneighbours.eu"
                      aria-label={t('header_library')}
                    >
                      {t('header_library')}
                    </a>
                  </li>
                  <li>
                    <LanguageSwitcher t={t} />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <nav
          className="navbar is-transparent"
          role="navigation"
          aria-label="main-navigation"
        >
          <div className="container">
            <div className="flexWrap">
              <SocialNetworks socialNetworks={socialNetworks} />
              <div className="logo">
                <Link to="/">
                  <div className="big">
                    {t('header_eu_neighbours')}
                  </div>
                  <div className="small">
                    {t('header_eu_east')}
                  </div>
                </Link>
              </div>
              <div className="searchBar">
                <div className="inputGroup">
                  <form id="searchForm" action="/" className="searchForm">
                    <label htmlFor="search">
                      <input
                        id="search" 
                        type="text" 
                        placeholder={t('header_search')} 
                        value={value}
                        onChange={event => this.handleChange(event)}
                        onKeyPress={event => this.onKeyPress(event)}
                      />
                    </label>
                  </form>
                  <button 
                    aria-label="search"
                    type="button"
                    onClick={() => this.searchEvent()}
                  >
                    <img src={search} alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="bottomMenu">
          <div className="container">
            <div className="flexWrap">
              <div>
                <a 
                  href="https://www.euneighbours.eu"
                  aria-label={t('header_home')}
                >
                  {t('header_home')}
                </a>
              </div>
              <div className="green">
                <a 
                  href="https://www.euneighbours.eu/east/eu-in-action"
                  aria-label={t('header_eu_in_action')}
                >
                  {t('header_eu_in_action')}
                </a>
              </div>
              <div>
                <a 
                  href="https://www.euneighbours.eu/east/stay-informed"
                  aria-label={t('header_eu_stay_informed')}
                >
                  {t('header_eu_stay_informed')}
                </a>
              </div>
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Navbar

Navbar.propTypes = {
  socialNetworks: PropTypes.array.isRequired,
}

